import Styled from "styled-components";
import Icon from 'components/Safra/Icon'
export const Container = Styled.div`
margin: 6%;

.resume {
    color: #00003C;
    font-weight: 700;
}

.star {
    float: right;
}

.hotel-name {
    color: #00003C;
    font-weight: 400;
    font-size: 17px;
}

.map {
    color: #00003C;
    font-weight: 400;
    font-size: 12px;
   // cursor: pointer;
    text-decoration: underline;
}

.label {
    color: #00003C;
    font-size: 17px;
}

`;

export const LocationMap = Styled(Icon).attrs({ name: 'map-pin' })`
color: var(--text-color);
height: 20px;
width: 20px;
`

export const ButtonLocation = Styled.button`

background: none;
border: none;
color: #6C6C6C;
font-weight: 400;
font-size: 13px;
text-decoration-line: underline;
`

export const CheckIn = Styled.div`
margin-top: 20px;
display: flex;
justify-content: space-between;

.top{
    margin-top: 7px;
}

p{
    color: #00003C;
    font-weight: 400;
    font-size: 17px;
    display: flex;
    flex-direction: column;
    text-align: center;

    span{
        color: rgba(38, 50, 56, 0.5);
        font-weight: 400;
        font-size: 13px;
    }
    
    @media(max-width: 800px) {
        margin-right: 20px;
       
}
}
`;

export const Line = Styled.div`
    border-bottom: 1px solid #C6C6C5;
    margin: 25px 0 20px;
`

export const Resumo = Styled.div`
background-color: #F0F0F0;
padding: 20px;
margin-top: 20px;

.title-resume{
    color: #00003C;
    font-weight: 400;
    font-size: 18px;
    font-weight: bold;
}

.title{
    color: #00003C;
    font-weight: 400;
    font-size: 15px;
    margin-bottom: 0;
   
}
.value{
    color: #6C6C6C;
    font-size: 13px;
}

.points{
    color: #00003C;
    font-weight: 400;
    font-size: 15px;   

}

.valor-total{
    color: #00003C;
    font-weight: 400;
    font-size: 17px;
    margin-top: 30px;
    
}
`

export const Span = Styled.span`
 float: right; 
 color: #6C6C6C !important;
 font-size: 13px;
`

export const Cupom = Styled.div`
background-color: #F0F0F0;
margin-top: 30px;
display: flex;
padding: 10px;
margin-bottom: 30px;

input{
    border: 0;
    background-color: #F0F0F0;
    border-bottom: 1px solid #C6C6C5;
    float: right;
    outline: none;
    width: 40%;
    margin-left: 20px;
}

label{
    color: #00003C;
    font-size: 17px;
    font-weight: 700;
}
`

export const Points = Styled.div`
display: flex;
flex-direction: row;
align-items: center;
margin-top: 6px;
margin-bottom: 20px;

.dots {
  flex: 1;
  border-bottom: 1px dashed #818181;
  margin-right: 10px;
  margin-left: 10px;
}
`;

export const Title = Styled.div`
    color: #00003C;
    font-weight: 400;
    font-size: 15px;
    margin-bottom: 0; 
`;

export const ValuePoints = Styled.div`
    color: #6C6C6C;
    font-size: 13px;
`;

export const Values = Styled.div`

display: flex;
flex-direction: row;
align-items: center;
padding-top: 20px;

.dots {
  flex: 1;
  border-bottom: 1px dashed #818181;
  margin-right: 10px;
  margin-left: 10px;
}

`;

export const GuestTitle = Styled.h2`
    color: #00003C;
    font-size: 20px;
    font-weight: 600;
    margin-top: 48px;
    margin-bottom: 8px;
`;

export const GuestSubTitle = Styled.p`
    color: #4F4F4F;
    font-size: 14px;
    margin-bottom: 32px;
`;

export const GuestSectionTitle = Styled.h3`
    color: #00003C;
    font-size: 16px;
    font-weight: 600;
    margin-bottom: 12px;
`;

export const CheckboxWrapper = Styled.label`
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 24px;
    cursor: pointer;
    font-size: 14px;
    font-weight: 400;
    color: #4F4F4F;
    letter-spacing: -0.8px;
    padding: 2px 0;
`;

export const Checkbox = Styled.input`
    appearance: none;
    width: 16px;
    height: 16px;
    border: 1px solid #00003C;
    border-radius: 4px;
    cursor: pointer;
    position: relative;
    flex-shrink: 0;

    &:checked {
        background-color: #00003C;
    }

    &:checked::after {
        content: '';
        position: absolute;
        top: 2px;
        left: 5px;
        width: 4px;
        height: 8px;
        border: solid white;
        border-width: 0 2px 2px 0;
        transform: rotate(45deg);
    }
`;

export const RefundBox = Styled.div`
    background: #F2F2F2;
    border-radius: 4px;
    padding: 24px;
    margin: 48px 0;
    display: flex;
    align-items: center;
    gap: 24px;

    .icon {
       
    }

    .content {
        h4 {
            color: #000000;
            font-size: 14px;
            font-weight: 500;
            margin-bottom: 5px;
        }
        p {
            color: #666666;
            font-size: 14px;
            margin-bottom: 0;
            line-height: 1.4;
        }
    }
`;
